export default {
    contentTitle: {
        guide: '活动指南',
        guideTooltip: '什么是活动？',
    },
    modulePageTooltip: {
        tooltip: '一起进行效果更好！',
    },
    questionAccuracy: {
        realtime: '实时',
        perQuestion: '按题目',
    },
};
